// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import third-party libraries
import { DateTime } from 'luxon';
function MetricListItem({ metric }) {
  return (
    <tr>
      <td className="_10">{metric.order}</td>
      <td className="_70"><a className="metric-title" href={`${window.authoringUrl}/metrics/${metric._id}`}>{metric.title}</a></td>
      {/* <td><em>Survey: {metric.survey ? "SURVEY" : ""}</em></td> */}
      
      <td className="_10">{DateTime.fromISO(metric.updated).toLocaleString(DateTime.DATE_SHORT)}</td>
    </tr>
  )
}

MetricListItem.propTypes = {
  metric: PropTypes.object.isRequired
}

export default MetricListItem;



// WEBPACK FOOTER //
// modules/metric/components/MetricListItem.js.jsx